import { Controller } from "@hotwired/stimulus"

// Simple expand/collapse toggle for content sections.
// Targets: content (the toggleable section), trigger (the button),
//          caret (rotation indicator), label (text to swap).
export default class extends Controller {
  static targets = ["content", "trigger", "caret", "label"]

  toggle(event) {
    // Allow the whole section band to be the click target: ignore clicks that originate inside the
    // collapsible content (form fields, buttons, nested toggles) so interacting with an expanded
    // section doesn't collapse it.
    if (event && this.hasContentTarget && this.contentTarget.contains(event.target)) return

    const content = this.contentTarget
    const isHidden = content.classList.contains("hidden")
    content.classList.toggle("hidden", !isHidden)

    if (this.hasCaretTarget) {
      this.caretTarget.classList.toggle("rotate-180", isHidden)
    }

    if (this.hasLabelTarget) {
      const el = this.labelTarget
      // Prefer explicit collapsed/expanded text (e.g. "+ Add a new …" / "− Add a new …") when
      // provided; otherwise fall back to the original "Show less"/total-text behavior.
      if (el.dataset.collapsedText || el.dataset.expandedText) {
        el.textContent = isHidden
          ? (el.dataset.expandedText || el.textContent)
          : (el.dataset.collapsedText || el.textContent)
      } else {
        const totalText = el.dataset.totalText
        el.textContent = isHidden ? "Show less" : (totalText || el.textContent)
      }
    }
  }
}
